import React, { useId } from "react";
import cn from "classnames";
import styles from "./Tag.module.scss";
import { Icon } from "../../../Icon/Icon";
import Button from "../../../Button";
function Tag(props) {
    const id = useId();
    return (React.createElement("div", { className: cn(styles.tag, !props.onClose && "!px-4") },
        React.createElement("div", { id: id, className: "max-w-full overflow-hidden text-ellipsis whitespace-nowrap" }, props.option.name),
        props.onClose && (React.createElement(Button, { kind: "icon", "aria-description": `Remove ${props.option.name}`, ariaLabel: "", className: "flex h-6 items-center justify-center pl-1", onClick: props.onClose, color: "white" },
            React.createElement(Icon, { className: "close-icon icon-[20px]" })))));
}
export default Tag;
//# sourceMappingURL=Tag.js.map